export const FETCH_CURRENCY_CONVERSION_RATES = 'FETCH_CURRENCY_CONVERSION_RATES';
export const FETCH_CURRENCY_CONVERSION_RATES_SUCCESS = 'FETCH_CURRENCY_CONVERSION_RATES_SUCCESS';
export const FETCH_CURRENCY_CONVERSION_RATES_FAILURE = 'FETCH_CURRENCY_CONVERSION_RATES_FAILURE';

export const REMOVE_CURRENCY_CONVERSION_RATE = 'REMOVE_CURRENCY_CONVERSION_RATE';
export const REMOVE_CURRENCY_CONVERSION_RATE_SUCCESS = 'REMOVE_CURRENCY_CONVERSION_RATE_SUCCESS';
export const REMOVE_CURRENCY_CONVERSION_RATE_FAILURE = 'REMOVE_CURRENCY_CONVERSION_RATE_FAILURE';

export const SAVE_CURRENCY_CONVERSION_RATE = 'SAVE_CURRENCY_CONVERSION_RATE';
export const SAVE_CURRENCY_CONVERSION_RATE_SUCCESS = 'SAVE_CURRENCY_CONVERSION_RATE_SUCCESS';
export const SAVE_CURRENCY_CONVERSION_RATE_FAILURE = 'SAVE_CURRENCY_CONVERSION_RATE_FAILURE';

export const UPLOADING_CURRENCY_CONVERSION_RATES = 'UPLOADING_CURRENCY_CONVERSION_RATES';
export const UPLOADING_CURRENCY_CONVERSION_RATES_SUCCESS = 'UPLOADING_CURRENCY_CONVERSION_RATES_SUCCESS';
export const UPLOADING_CURRENCY_CONVERSION_RATES_FAILURE = 'UPLOADING_CURRENCY_CONVERSION_RATES_FAILURE';

export const IMPORT_CURRENCY_CONVERSION_RATES = 'IMPORT_CURRENCY_CONVERSION_RATES';
export const IMPORT_CURRENCY_CONVERSION_RATES_SUCCESS = 'IMPORT_CURRENCY_CONVERSION_RATES_SUCCESS';
export const IMPORT_CURRENCY_CONVERSION_RATES_FAILURE = 'IMPORT_CURRENCY_CONVERSION_RATES_FAILURE';

export const IMPORT_CURRENCY_CONVERSION_RATES_PROGRESS = 'IMPORT_CURRENCY_CONVERSION_RATES_PROGRESS';

export const CALCULATE_MISSING_RATES = 'CALCULATE_MISSING_RATES';
export const CLEAR_UPLOADED_RATES = 'CLEAR_UPLOADED_RATES';
